<template>
  <div id="app" :class="[isMobile ? 'mobile' : 'pc']">
    <div class="theme-e" :class="{ 'has-bar': hasBuyBar }">
      <headerVue :key="'hd' + componentKey" />
      <div class="e-stage">
        <div class="e-body">
          <router-view @refresh="handleRefresh" />
        </div>
        <footerVue :key="'ft' + componentKey" />
      </div>
    </div>
  </div>
</template>

<script>
import headerVue from './views/headerE.vue';
import footerVue from './views/footerE.vue';

// E 套两款字体：display / body
const FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Instrument+Serif:ital@0;1&family=Manrope:wght@400;500;600;700;800&display=swap';

export default {
  components: { headerVue, footerVue },
  data() {
    return {
      isMobile: false,
      componentKey: 0,
    }
  },
  computed: {
    // 移动端详情页、话费页底部有固定购买条，给页面多让出一段
    hasBuyBar() {
      return this.isMobile && /^\/(topup\/|mobile)/.test(this.$route.path)
    },
  },
  created() {
    this.loadFonts()
  },
  mounted() {
    this.isMobile = !!this._isMobile()
  },
  methods: {
    // 只有 E 套才拉这两款字体，A/B/C/D 不受影响
    loadFonts() {
      if (document.getElementById('theme-e-fonts')) return;
      const link = document.createElement('link')
      link.id = 'theme-e-fonts'
      link.rel = 'stylesheet'
      link.href = FONT_HREF
      document.head.appendChild(link)
    },
    _isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    handleRefresh() {
      this.componentKey += 1
    },
  },
}
</script>

<style lang="scss">
@import './assets/css/reset.scss';
@import './assets/css/theme-e.scss';

html.mobile {
  font-size: 13.3333vw;
  background: #F4F1EA;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;

  &.pc {
    min-width: 1200px;
    overflow-x: auto;
  }
}

/* A/B/C/D 的 App*.vue 都给 #app.pc 设了 overflow-x:auto，且它们的全局样式一样会打进包里。
   一个轴设成 auto 会让另一个轴的 visible 被算成 auto，#app 于是成了滚动容器，
   theme-e 里所有 position:sticky（详情页左屏）都会改为相对它定位而失效。
   这里用 html 前缀把优先级抬到 (1,1,1)，压过那几条同名规则，且不受打包顺序影响。
   横向溢出交还给窗口，只影响 E 套。 */
html #app.pc {
  overflow-x: visible;
}
</style>
